'use strict';

angular.module('extra2App')
   .directive('ckListItem', ['restservice', function (restservice) {
   return {
      templateUrl: 'views/directives/list-item.html',
      restrict: 'E',
      link: function (scope) {

            scope.iconsBasePath = restservice.getIconsBasePath();
            
         }
      };
}]);